import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  AssignCarParkToUnitGQL,
} from "../../../../generated/graphql";
import { ActivatedRoute } from "@angular/router";
import { MatAutocomplete, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { Observable } from "rxjs";
import { MatChipInputEvent } from "@angular/material/chips";
import { FormControl, FormGroup } from "@angular/forms";
import { FormValidators } from "../../form-validators/form-validators";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { SnackBarService } from "../../service/snack.bar.service";
import { GraphQLError } from "graphql/error";

export interface DialogData {
  labelTitle: string;
  unitData: any[];
  carParkUnit: any[];
}
@Component({
  selector: "car-park-dialog",
  templateUrl: "car-park-dialog.html",
  styleUrls: []
})

export class CarParkDialog {

  //#region general
  project: any[];
  selectedunit: [];
  unitNo: string[] = [];
  projectId: string;
  carparkFormGrp: FormGroup;
  selected: boolean = false;
  unitList: any[] = [];
  unitlist: any;
  unitPage: number = 1;
  unitScrollReachBottom: boolean = false;
  unitScrollIsActive: boolean = true;
  unitId: string;
  obj: any;

  /* Chips autocomplete */

  unitArray: any = [];
  //#endregion

  //#region carpark
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  carParkCtrl = new FormControl();
  filteredCarPark: Observable<any[]>;
  initCarpark: any = [];
  choosenCarpark: any = [];
  allCarPark: any = [];
  carparkID: any = [];
  //#endregion

  @ViewChild('carParkInput', { static: false }) carParkInput: ElementRef<HTMLInputElement>;
  @ViewChild('carpark') matAutocomplete: MatAutocomplete;
  @ViewChild("unit", { static: false }) unitAutocomplete: MatAutocomplete;

  constructor(
    private activatedRoute: ActivatedRoute,
    private snackBarService: SnackBarService,
    private assignCarParkToUnitGQL: AssignCarParkToUnitGQL,
    public dialogRef: MatDialogRef<CarParkDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    let snapshotParam: any = this.activatedRoute.queryParams;
    this.projectId = snapshotParam._value.project_id;
    this.unitList = data?.unitData;
    for (let unit of this.unitList) {
      unit.carPark = [];
    }

    //to make sure the data accessible to all function
    this.initCarpark = data?.carParkUnit

    //to assign the whole data as the 1st option to choose, changeable
    this.allCarPark = data?.carParkUnit;

    this.filteredCarPark = Object.assign([], this.initCarpark);

    this.initForm();
  }

  private initForm() {
    this.carparkFormGrp = new FormGroup({

      carParkCtrl: new FormControl(["", FormValidators.forbiddenObjectValidator])
    });

    this.carparkFormGrp.controls.carParkCtrl.valueChanges.subscribe(x => {
      if (typeof x !== "object") {
        let carparks = this.allCarPark;
        if (x) {
          carparks = this.allCarPark.filter((y) =>
            y.unitNo.toUpperCase().includes(x.toUpperCase())
          );
        }
        this.filteredCarPark = Object.assign([], carparks);
      }
    });
  }

  //   //#region carpark
  addCarPark(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.choosenCarpark.push(value);
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }

    this.carparkFormGrp.controls.carparkCtrl.setValue(null)
  }

  removeCarPark(cp: any): void {
    this.unitList = this.unitList.map(obj => ({
      ...obj,
      carPark: obj.carPark.filter(x => x != cp)
    }));
    this.choosenCarpark = this.choosenCarpark.filter(x => x.id != cp.id);
    this.filteredCarPark = this.initCarpark.filter(
      (x) => !this.choosenCarpark.includes(x)
    );
    // }
  }

  selectedCarPark(event: MatAutocompleteSelectedEvent, i: any): void {
    this.choosenCarpark.push(event.option.value);
    this.unitList[i].carPark.push({
      name: event.option.value.unitNo,
      id: event.option.value.id
    });

    this.filteredCarPark = this.initCarpark.filter(
      (x) => !this.choosenCarpark.includes(x)
    );
    this.allCarPark = this.filteredCarPark

    this.carParkInput.nativeElement.value = '';
    this.carParkCtrl.setValue(null);
  }
  //#endregion

  async save() {
    let submitData = [];

    this.unitList.forEach((x) => {
      if (x.carPark.length > 0) {
        let temp = {
          unitId: x.source.id,
          unitNo: x.source.unitNo,
          carPark: x.carPark.map(y => {
            return {
              carParkId: y.id,
              carParkNo: y.name
            }
          })
        }
        submitData.push(temp)
      }
    })

    if (submitData.length == 0)
      return this.snackBarService.show(`Unable to assign car park`);

    this.assignCarParkToUnitGQL
      .mutate({
        input: {
          variable: submitData,
          projectId: this.projectId,
        }
      },
        {
          context: {
            useMultipart: true,
          },
        }).subscribe(
          (result) => {
            if (result) {
              this.snackBarService.show(`Assigned successfully`);
            }
            this.dialogRef.close();
          }, (err: GraphQLError) => {
            this.snackBarService.showMutationError(err);
          }
        )
  }

  cancel() {
    this.allCarPark = [];
  }
}